import { Button, createStyles, makeStyles, Theme, Typography } from "@material-ui/core";
import { Person } from "@material-ui/icons";
import AssignmentLate from "@material-ui/icons/AssignmentLate";
import React, { FC, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { routesPaths } from "../../Routes";
import { useGetMeQuery } from "../../api/rtk/MeApi";
import { PersonType } from "../../model/PersonType";
import TranslatedMessage from "../translations/TranslatedMessage";
import HomeSection from "./HomeSection";
import MandatoryFieldsAlert from "./MandatoryFieldsAlert";
import MyCourses from "./MyCourses";
import MyExamCases from "./MyExamCases";
import MyExamResults from "./MyExamResults";
import MyExamSessions from "./MyExamSessions";
import MyTasks from "./MyTasks";
import MyUser from "./MyUser";
import MyExams from "./myExams/MyExams";
import { clearCart, getCart } from "../../api/CartApi";
import Alert from "@material-ui/lab/Alert";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    cartMessageWrapper: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: theme.spacing(1) + "px",
    },
    alertMessage: {
      display: "flex",
    },
    cartMessage: {
      display: "flex",
      alignItems: "center",
    },
  })
);

type HomeProps = {
  viewType?: PersonType;
};

const Home: FC<HomeProps> = (props) => {
  const classes = useStyles({});
  const history = useHistory();
  const { data: me, isFetching: isMeFetching } = useGetMeQuery();
  const personType = !props.viewType ? me?.type : props.viewType;
  const [showResumeCartMessage, setShowResumeCartMessage] = useState(false);

  useEffect(() => {
    let unmounted = false;

    if (personType === PersonType.Candidate) {
      getCart().then((cart) => {
        if (!unmounted) {
          if ((cart.modules?.length ?? 0) > 0) {
            setShowResumeCartMessage(true);
          }
        }
      });

      return () => {
        unmounted = true;
      };
    }
  }, [personType]);

  const onClickNo = async () => {
    clearCart().then(() => {
      setShowResumeCartMessage(false);
    });
  };

  if (isMeFetching) {
    return <></>;
  }

  return (
    <>
      {personType === PersonType.Internal && (
        <>
          <HomeSection icon={<Person />} title={<TranslatedMessage id="home.me" />}>
            <MyUser />
          </HomeSection>
        </>
      )}
      {personType === PersonType.Candidate && (
        <>
          <Typography variant="h5">
            <TranslatedMessage id="home.candidate" />
          </Typography>
          {me?.type === PersonType.Expert && (
            <Link to={routesPaths.expertHome()}>
              <TranslatedMessage id="home.switch.expert" />
            </Link>
          )}
          <MandatoryFieldsAlert />
          {showResumeCartMessage && (
            <Alert severity="info" className={classes.cartMessageWrapper} classes={{ message: classes.alertMessage }}>
              <div className={classes.cartMessage}>
                <TranslatedMessage id="home.pendingItemsInCartMessage" />
              </div>
              <Button color="primary" onClick={() => history.push(routesPaths.startCertification())}>
                {<TranslatedMessage id="common.yes" />}
              </Button>
              <Button color="secondary" onClick={onClickNo}>
                {<TranslatedMessage id="common.no" />}
              </Button>
            </Alert>
          )}
          <MyExams />
          <MyExamResults />
          <MyCourses />
          <HomeSection icon={<AssignmentLate />} title={<TranslatedMessage id="home.myTasks" />}>
            <MyTasks />
          </HomeSection>
        </>
      )}
      {personType === PersonType.Expert && (
        <>
          <Typography variant="h5">
            <TranslatedMessage id="home.expert" />
          </Typography>
          <Link to={routesPaths.candidateHome()}>
            <TranslatedMessage id="home.switch.candidate" />
          </Link>
          <MandatoryFieldsAlert />
          <HomeSection icon={<AssignmentLate />} title={<TranslatedMessage id="home.myTasks" />}>
            <MyTasks />
          </HomeSection>
          <MyExamSessions />
          <MyExamCases />
        </>
      )}
    </>
  );
};

export default Home;
